/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Song
 */
export interface Song {
    /**
     * 
     * @type {string}
     * @memberof Song
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Song
     */
    artist: string;
    /**
     * 
     * @type {string}
     * @memberof Song
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Song
     */
    remark: string;
    /**
     * 
     * @type {string}
     * @memberof Song
     */
    audioUrl: string;
}

/**
 * Check if a given object implements the Song interface.
 */
export function instanceOfSong(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "artist" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "remark" in value;
    isInstance = isInstance && "audioUrl" in value;

    return isInstance;
}

export function SongFromJSON(json: any): Song {
    return SongFromJSONTyped(json, false);
}

export function SongFromJSONTyped(json: any, ignoreDiscriminator: boolean): Song {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'artist': json['artist'],
        'name': json['name'],
        'remark': json['remark'],
        'audioUrl': json['audioUrl'],
    };
}

export function SongToJSON(value?: Song | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'artist': value.artist,
        'name': value.name,
        'remark': value.remark,
        'audioUrl': value.audioUrl,
    };
}

